import { World } from 'prismarine-world/types/world';
import { LevelDatFull } from 'prismarine-provider-anvil/src/level';
import { Vec3 } from 'vec3';
export declare const server: (serv: Server, options: Options) => Promise<void>;
export declare const player: (player: Player, serv: Server, settings: Options) => void;
export interface CustomWorld extends World {
    blockEntityData: Record<string, any>;
    portals: any[];
    seed: number;
}
export declare const usedServerPathsV1: string[];
declare global {
    interface Server {
        /** Global spawn and respawn point for every player */
        spawnPoint?: Vec3;
        /** Parsed level.dat of the loaded world (only if worldFolder is specificed) */
        levelData?: LevelDatFull;
        /** Contains the overworld world. This is where the default spawn point is */
        "overworld": CustomWorld;
        /** Contains the nether world. This **WILL** be used when a player travels through a portal if they are in the overworld! */
        "netherworld": CustomWorld;
        /** Saves block in world and sends block update to all players of the same world. */
        "setBlock": (world: CustomWorld, position: Vec3, stateId: number) => Promise<void>;
        /** Sends a block action to all players of the same world. */
        "setBlockAction": (world: CustomWorld, position: Vec3, actionId: number, actionParam: any) => Promise<void>;
    }
    interface Player {
        /** If `worldFolder` option is set, save player's data into `<worldFolder>/playerdata/<UUID>.dat`. Returns promise.
         * Example: save all players data to disk:
         *
         * ```js
         * for (const player of serv.players) {
         *   player.save()
         * }
         * ```
         */
        'save': () => Promise<any>;
        /** The world object which the player is in (use serv.overworld, serv.netherworld, serv.endworld, or a custom world). Options:
         *
         * - gamemode: Gamemode of the world (Default is player gamemode)
         * - difficulty: Difficulty of world. Default is 0 (easiest)
         * - dimension: Dimension of world. 0 is Overworld, -1 is Nether, 1 is End (Default is 0)
         */
        'changeWorld': (world: any, opt: any) => Promise<void>;
    }
}
